'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _ListElementPresentational = require('./ListElementPresentational');

var _ListElementPresentational2 = _interopRequireDefault(_ListElementPresentational);

var _ListElementContainer = require('./ListElementContainer');

var _ListElementContainer2 = _interopRequireDefault(_ListElementContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var ListElement = function ListElement(props) {
    var isPresentational = props.isPresentational;

    var DisplayElement = isPresentational ? _ListElementPresentational2.default : _ListElementContainer2.default;
    return _react2.default.createElement(DisplayElement, props);
}; // Lib


ListElement.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    isPresentational: _propTypes2.default.bool,
    inList: _propTypes2.default.string
};

exports.default = (0, _recompose.pure)(ListElement);


//////////////////
// WEBPACK FOOTER
// ./src/client/list/ListElement.js
// module id = 745
// module chunks = 0